import { useTranslation } from "react-i18next";
import { Button } from "components/button";

interface ToggleAllButtonProps {
  allOpen: boolean;
  onToggle: () => void;
}

export const ToggleAllButton = ({
  allOpen,
  onToggle,
}: ToggleAllButtonProps) => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <Button
      variant="ghost"
      size="small"
      onClick={onToggle}
      className="h-auto px-1 py-0 text-xs text-secondary-400 hover:text-secondary-600 hover:bg-transparent"
      data-testid="toggle-all-button"
    >
      {allOpen
        ? t("productDetails:rawData.collapseAll")
        : t("productDetails:rawData.expandAll")}
    </Button>
  );
};
